import { Injectable, NgModule } from '@angular/core';
import { RouterModule, RouterStateSnapshot, Routes, TitleStrategy } from '@angular/router';
import { CustomErrorComponent } from './shared/components/custom-error/custom-error.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { Title } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { AuthComponent } from './shared/components/auth/auth.component';
import { NotAuthorizedComponent } from './shared/components/not-authorized/not-authorized.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./content/pages/pages.module').then(m => m.PagesModule),
  },
  {
    path: 'authorize',
    // component: AuthComponent,
    redirectTo:'',
    pathMatch: 'full',
  },
  {
    path: 'error',
    title: 'Error Page',
    component: CustomErrorComponent
  },
  {
    path: 'notauthorized',
    title: 'Not Authorized',
    component: NotAuthorizedComponent
  },
  { path: 'verification-guardian-parent-child', loadChildren: () => import('./modules/verification-guardian-parent-child/verification-guardian-parent-child.module').then(m => m.VerificationGuardianParentChildModule) },
  {
    path: '**',
    title: 'Not Found',
    component: NotFoundComponent,
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { paramsInheritanceStrategy: 'always'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
